/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

export interface IBusinessSignUpRadioButtonProps {
    id: string;
    isRequired: boolean;
    options: IBusinessSignUpRadioButtonOptionProps[];
}

export interface IBusinessSignUpRadioButtonOptionProps {
    id: string;
    name: string;
    value: string;
    label: string;
    className: string;
    onChange(event: React.ChangeEvent<HTMLInputElement>): void;
}

export const BusinessSignUpRadioButtonOption: React.FC<IBusinessSignUpRadioButtonOptionProps> = props => {
    const { id, name, value, label, className, onChange } = props;
    return (
        <div className={className}>
            <input type='radio' id={id} name={name} value={value} onChange={onChange} />
            <label htmlFor={id}>{label}</label>
        </div>
    );
};

export default BusinessSignUpRadioButtonOption;
